import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state: {
    isFetchedAps: false,
    payloadServidorAps: {},
    payloadCliente: {},
    puxarCliente: false,
    habilitarQuestionarioAps: false,
    temAps: false,
    unimed: "",
    listaProntuarios: []
  },
  mutations,
  actions,
  getters
};
